export default {
  isAgency() {
    const roles = this.$store.state.user.roles || []

    return roles.includes('ROLE_AGENCY')
  },

  /**
   * Only paid Pagar.me orders can be cancelled with a refund from here.
   */
  isAvailable() {
    return this.isAgency && this.order.refundable === true
  },

  refundableAmount() {
    return this.order.refundableAmount || 0
  },

  formattedRefundableAmount() {
    return this.formatAmount(this.refundableAmount)
  },

  formattedAmount() {
    return this.formatAmount(this.amount)
  },

  amountExceedsLimit() {
    return this.amount > this.refundableAmount
  },

  amountIsValid() {
    return this.amount > 0 && !this.amountExceedsLimit
  },

  /**
   * Percentage of the refundable amount, derived from `amount`. Editing it
   * writes back to `amount`, so both fields always stay in sync and there
   * is a single source of truth.
   */
  percent: {
    get() {
      if (!this.refundableAmount) {
        return 0
      }

      return this.round2((this.amount / this.refundableAmount) * 100)
    },
    set(value) {
      const clamped = Math.max(0, Math.min(100, value || 0))

      this.amount = this.round2(this.refundableAmount * clamped / 100)
    }
  }
}
